import { useApi } from "../../utils/api/useApi";
import { useToastNotification } from "../useToastNotification/useToastNotification";
import { existingPrimaryInvitationInformationEndpoint } from "../../utils/api/urls";
import { ExistingPrimaryInvitationInformationDto } from "../../models/ExistingPrimeryInvitationInformationDto";

export const useExistingPrimaryInvitationInformation = () => {
  const { get } = useApi<ExistingPrimaryInvitationInformationDto>();
  const { showNotification } = useToastNotification();

  const getExistingPrimaryInvitationInformationSafely = async (
    workflowId: string
  ): Promise<ExistingPrimaryInvitationInformationDto | null> => {
    try {
      const response = await get(existingPrimaryInvitationInformationEndpoint, {
        params: { workflowId }
      });
      return response;
    } catch (err: any) {
      showNotification(err?.message || "Error getting move invitation information", "error");
      return null;
    }
  };

  return { getExistingPrimaryInvitationInformationSafely };
};
